// extracted by mini-css-extract-plugin
export default {"offersContainer":"VzsaorhTNK","offersHeaderTitle":"ko_g41AxUU"};